import { IFeature } from '../../../state/stores/Feature/FeatureModel';
import { IPathModel } from '../../../state/stores/Path/PathModel';
import { SessionContainerProps } from '../config';
import { observer } from 'mobx-react';
import { useFocusEffect } from 'expo-router';
import { useStores } from '../../../hooks/useStores';


export interface RadarData extends Record<string, unknown> {
  contentId: string;
  pathId?: string;
  height?: number;
  width?: number;
  // Feature data
  feature?: IFeature | null;
  valPercentage: number;
  // User and path data
  recommendedPath?: IPathModel | null;
  isAnonymous: boolean;
  hasAccessToEvolunoAssistance: boolean;
  showAssistanceButton: boolean;
}

export const ContainRadar = observer(({ onNext, onFinish, children }: SessionContainerProps<RadarData>) => {
  const rootStore = useStores();

  // Extract data from treeNav.content
  const contentId = rootStore.treeNav.content.sessionStep?.contentId;
  const pathId = rootStore.treeNav.content.session?.path;

  // Extract feature data
  const feature = contentId ? rootStore?.feature.getFeature(contentId) : null;
  let valPercentage = 0;
  if (feature?.value && feature?.maxValue) {
    valPercentage = Math.round(100 * feature.value / feature.maxValue);
    if (feature?.lowIsBetter) {
      valPercentage = 100 - valPercentage;
    }
  }

  // Get user and company data
  const isAnonymous = rootStore?.user.anonymous || false;
  const hasAccessToEvolunoAssistance = rootStore?.user?.company?.hasAccessToEvolunoAssistance || false;

  // Get recommended path
  const recommendedPaths = rootStore?.user?.recommendedPaths;
  const recommendedPath = recommendedPaths && recommendedPaths.length > 0
    ? rootStore?.path.getPath(recommendedPaths[0])
    : null;

  // Calculate if assistance button should be shown
  const showAssistanceButton = feature?.logo !== 'NORMAL' &&
    hasAccessToEvolunoAssistance &&
    !pathId &&
    !isAnonymous;

  // Fetch user profile when component focuses (similar to legacy RadarSession)
  useFocusEffect(() => {
    if (!isAnonymous) {
      rootStore?.user.fetchProfile(rootStore?.language.language);
    }
  });

  const presentationProps = {
    onNext,
    onFinish,
    data: {
      contentId: contentId || '',
      pathId: pathId || undefined,
      height: 800, // Default height, can be overridden by parent
      width: 400,  // Default width, can be overridden by parent
      feature,
      valPercentage,
      recommendedPath,
      isAnonymous,
      hasAccessToEvolunoAssistance,
      showAssistanceButton,
    },
    labels: rootStore?.language.translate.MOBILE?.SESSION,
  };

  return children(presentationProps);
});
